import { QueryClient } from "@tanstack/react-query";

/**
 * Instancia unica de QueryClient para toda la app.
 *
 * Los defaults son deliberadamente conservadores (staleTime/gcTime moderados,
 * sin refetch pasivo por defecto) porque no hay onSnapshot en el proyecto: la
 * unica forma de que un dato se vuelva stale es el paso del tiempo o una
 * invalidacion explicita tras una mutacion. Cada dominio de datos ajusta
 * estos defaults en su propio useQuery/useInfiniteQuery segun su frecuencia
 * real de cambio (ver plan de migracion).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 10 * 60 * 1000,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 2 * 60 * 1000,
    },
  },
});
